module.exports = __webpack_public_path__ + "img/TK.90092795.png";